// removed by extract-text-webpack-plugin
module.exports = {"icon":"Avatar_icon_As2dY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.css
// module id = 89
// module chunks = 0